import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './comparison.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var Comparison = /** @class */ (function (_super) {
    tslib_1.__extends(Comparison, _super);
    function Comparison(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.comparisonJson = [];
        return _this;
    }
    Comparison.prototype.init = function () {
        var storage = localStorage.getItem('comparison');
        this.variableName = this.element.getAttribute('data-variablename');
        this.imagePath = this.element.getAttribute('data-imagepath');
        this.productKey = this.element.getAttribute('data-productkey');
        this.producttype = this.element.getAttribute('data-producttype');
        this.comparisonJson = [];
        this.switcherIndex = {};
        if (this.producttype) {
            this.producttype = this.producttype.toLowerCase();
        }
        if (!storage) {
            storage = {};
            storage[this.productKey] = [];
            localStorage.setItem('comparison', JSON.stringify(storage));
        }
        else {
            storage = JSON.parse(storage);
            if (!storage[this.productKey]) {
                storage[this.productKey] = [];
                localStorage.setItem('comparison', JSON.stringify(storage));
            }
        }
        if (this.element.getAttribute('data-description-text')) {
            this.textDescription = this.element.getAttribute('data-description-text');
        }
        else {
            this.textDescription = 'Description';
        }
        if (this.element.getAttribute('data-benefits-text')) {
            this.textBenefits = this.element.getAttribute('data-benefits-text');
        }
        else {
            this.textBenefits = 'Benefits and key features';
        }
        this.comparison = storage;
        this.benefitToggle = $('.js-toggle-benefits');
        this.comparisonChip = $('.comparison__compare-chip');
        this.getProducts();
        this.normalizeHeight();
        this.addCompareCheckDiv();
    };
    Comparison.prototype.bindEvents = function () {
        var _this = this;
        $('.js-remove-all').click(function () {
            $('.comparison__slot').css('order', 99);
            _this.resetSlots();
            _this.resetMobile();
            $('.comparison').removeClass('comparison--comparing');
            $(".comparison .form__control--checkbox input").removeAttr('disabled');
            $(".comparison .form__control--checkbox input").prop('checked', false);
            _this.element.getElementsByClassName('comparison__check--details')[0].classList.add('comparison__check--details--hide');
            _this.comparison[_this.productKey] = [];
            localStorage.setItem('comparison', JSON.stringify(_this.comparison));
        });
        $(document).on('click', '.js-toggle-benefits', function (e) {
            $('.comparison__product__benefits__accordion').toggleClass('comparison__product__benefits__accordion--open');
            $('.comparison__product__benefits').toggleClass('comparison__product__benefits--open');
        });
        $(document).on('click', '.comparison__mobile__accordion', function (e) {
            if ($(e.currentTarget).hasClass('comparison__mobile__accordion--open')) {
                $(e.currentTarget).toggleClass('comparison__mobile__accordion--open');
            }
            else {
                $('.comparison__mobile__accordion').removeClass('comparison__mobile__accordion--open');
                setTimeout(function () {
                    $(e.currentTarget)
                        .toggleClass('comparison__mobile__accordion--open')
                        .queue(function (next) {
                        $('html,body').animate({
                            scrollTop: $(e.currentTarget).offset().top - 70
                        }, 'slow');
                        next();
                    });
                }, 700);
            }
        });
        $(document).on('click', '.comparison__mobile__accordion__content', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
        });
        $(document).on('click', '.comparison__mobile__graph-switcher__arrow--left', function (e) {
            var key = $(e.currentTarget).parent().data('key');
            if (_this.switcherIndex[key] == 0) {
                _this.switcherIndex[key] = _this.pricingJson[key].length - 1;
            }
            else {
                _this.switcherIndex[key]--;
            }
            var productTitle = _this.pricingJson[key][_this.switcherIndex[key]].productTitle;
            var productId = _this.pricingJson[key][_this.switcherIndex[key]].id;
            var productLink = _this.pricingJson[key][_this.switcherIndex[key]].productLink;
            var productButtons = _this.pricingJson[key][_this.switcherIndex[key]].buttons;
            $(".comparison__mobile__graph-switcher__value[data-key='" + key + "']")
                .text(productTitle);
            $(".comparison__mobile__accordion[data-section='" + key + "'] .comparison__mobile__graph__bar__fill")
                .removeClass('comparison__mobile__graph__bar__fill--active');
            $(".comparison__mobile__accordion[data-section='" + key + "'] .comparison__mobile__graph-item[data-id='" + productId + "'] .comparison__mobile__graph__bar__fill")
                .addClass('comparison__mobile__graph__bar__fill--active');
            var productButtonsHtml = "";
            var btnCount = 0;
            productButtons.forEach(function (btn) {
                btnCount++;
                productButtonsHtml += _this.renderButtons(btn, productButtons.length == btnCount, productButtons, btnCount);
            });
            $(".comparison__mobile__accordion[data-section='" + key + "'] .comparison__mobile-graph-buttons").html(productButtonsHtml);
            //comparison__mobile-graph-buttons
            //Analytics
            var $dtmtargetParentContainer = $(e.currentTarget).parents("div.comparison__mobile__accordion__content");
            if ($dtmtargetParentContainer.length) {
                $dtmtargetParentContainer.attr("data-trackingregion", "compare " + _this.producttype + " > " + productTitle);
                $dtmtargetParentContainer.find("a.js-apply-now-modal-open").eq(0).attr("data-text", productTitle + " | apply now button click").attr("data-id", "link_content_compare " + _this.producttype);
                $dtmtargetParentContainer.find("a.comparison__mobile__graph__tell-me-more").eq(0).attr("data-text", productTitle + " | tell me more button click").attr("data-id", "link_content_compare " + _this.producttype);
            }
        });
        $(document).on('click', '.comparison__mobile__graph-switcher__arrow--right', function (e) {
            var key = $(e.currentTarget).parent().data('key');
            if (_this.switcherIndex[key] == _this.pricingJson[key].length - 1) {
                _this.switcherIndex[key] = 0;
            }
            else {
                _this.switcherIndex[key]++;
            }
            var productTitle = _this.pricingJson[key][_this.switcherIndex[key]].productTitle;
            var productId = _this.pricingJson[key][_this.switcherIndex[key]].id;
            var productLink = _this.pricingJson[key][_this.switcherIndex[key]].productLink;
            var productButtons = _this.pricingJson[key][_this.switcherIndex[key]].buttons;
            $(".comparison__mobile__graph-switcher__value[data-key='" + key + "']")
                .text(productTitle);
            $(".comparison__mobile__accordion[data-section='" + key + "'] .comparison__mobile__graph__bar__fill")
                .removeClass('comparison__mobile__graph__bar__fill--active');
            $(".comparison__mobile__accordion[data-section='" + key + "'] .comparison__mobile__graph-item[data-id='" + productId + "'] .comparison__mobile__graph__bar__fill")
                .addClass('comparison__mobile__graph__bar__fill--active');
            var productButtonsHtml = "";
            var btnCount = 0;
            productButtons.forEach(function (btn) {
                btnCount++;
                productButtonsHtml += _this.renderButtons(btn, productButtons.length == btnCount, productButtons, btnCount);
            });
            $(".comparison__mobile__accordion[data-section='" + key + "'] .comparison__mobile-graph-buttons").html(productButtonsHtml);
            //Analytics
            var $dtmtargetParentContainer = $(e.currentTarget).parents("div.comparison__mobile__accordion__content");
            if ($dtmtargetParentContainer.length) {
                $dtmtargetParentContainer.attr("data-trackingregion", "compare " + _this.producttype + " > " + productTitle);
                $dtmtargetParentContainer.find("a.js-apply-now-modal-open").eq(0).attr("data-text", productTitle + " | apply now button click").attr("data-id", "link_content_compare " + _this.producttype);
                $dtmtargetParentContainer.find("a.comparison__mobile__graph__tell-me-more").eq(0).attr("data-text", productTitle + " | tell me more button click").attr("data-id", "link_content_compare " + _this.producttype);
            }
        });
        window.addEventListener('resize', this.debounce(function () {
            _this.normalizeHeight();
        }, 50, false));
    };
    Comparison.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    Comparison.prototype.normalizeHeight = function () {
        var products = $('.comparison__product-wrapper');
        var minHeight = 0;
        if (products.length > 0) {
            products.each(function (idx, el) {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            $('.comparison__placeholder--col').css('min-height', minHeight + "px");
        }
        var descriptions = $('.comparison__product__section[data-section="description"]');
        minHeight = 0; //reset
        if (descriptions.length > 0) {
            descriptions.each(function (idx, el) {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            $('.comparison__product__section[data-section="description"]').css('min-height', minHeight + "px");
        }
        var applications = $('.comparison__product__section[data-section="apply"]');
        minHeight = 0; //reset
        if (applications.length > 0) {
            applications.each(function (idx, el) {
                if ($(el).height() > minHeight) {
                    minHeight = $(el).height();
                }
            });
            $('.comparison__product__section[data-section="apply"]').css('min-height', minHeight + "px");
        }
        var benefits = $('.comparison__product__benefits');
        minHeight = 0; //reset
        if (benefits.length > 0) {
            benefits.each(function (idx, el) {
                if ($(el).outerHeight() > minHeight) {
                    minHeight = $(el).outerHeight();
                }
            });
            $('.comparison__product__benefits').css('min-height', minHeight + "px");
        }
        var buttons = $('.comparison__product__section-buttons');
        minHeight = 0; //reset
        if (buttons.length > 0) {
            buttons.each(function (idx, el) {
                if ($(el).height() > minHeight) {
                    minHeight = $(el).height();
                }
            });
            $('.comparison__product__section-buttons').css('min-height', minHeight + "px");
        }
    };
    Comparison.prototype.getProducts = function () {
        var _this = this;
        this.productJson = window[this.variableName];
        var comparisonMatch = false;
        this.productJson.forEach(function (product, idx, arr) {
            _this.renderComparisonChips(product);
            $('.js-compare').click(function (e) { return _this.compareClick(e); });
            $('.comparison .form__control--checkbox').click(function (e) { return _this.compareCheckClick(e); });
            if (_this.comparison[_this.productKey].find(function (item) { return item == product.id; })) {
                _this.comparisonJson.push(product);
                var docfragment = document.createDocumentFragment();
                docfragment.appendChild(_this.renderProduct(product));
                _this.renderSlot(docfragment);
                $(".comparison__compare-chip[data-id=\"" + product.id + "\"]").addClass('comparison__compare-chip--active');
                comparisonMatch = true;
            }
        });
        if (comparisonMatch) {
            this.renderMobile();
            if (!$('.comparison').hasClass('comparison--comparing')) {
                $('.comparison').addClass('comparison--comparing');
            }
            this.normalizeHeight();
        }
        if (this.comparison) {
            this.comparison[this.productKey].forEach(function (id) {
                $(".comparison .form__control--checkbox[data-id='" + id + "'] input").prop('checked', 'checked');
            });
            if (this.comparison[this.productKey].length >= 3) {
                $(".comparison.form__control--checkbox input").prop('disabled', 'disabled');
                this.comparison[this.productKey].forEach(function (id) {
                    $(".comparison.form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                });
            }
        }
    };
    Comparison.prototype.addCompareCheckDiv = function () {
        var displayDiv = document.createElement("div");
        displayDiv.classList.add("col-12");
        displayDiv.classList.add("comparison__check");
        var display = "<span class=\"comparison__check--details comparison__check--details--hide\">\n\t\tOnly 3 items can be compared. Please deselect an item to select another item.\n\t\t</span>";
        displayDiv.innerHTML = display;
        var divToAppendTo = this.element.getElementsByClassName('title title--page text-center');
        if (divToAppendTo.length == 0) {
            divToAppendTo = this.element.getElementsByClassName('title title--entrance');
        }
        if (divToAppendTo.length > 0) {
            divToAppendTo[0].parentNode.append(displayDiv);
        }
    };
    Comparison.prototype.compareCheckClick = function (e) {
        var isDisabled = e.currentTarget.getElementsByClassName("js-compare")[0].disabled;
        if (isDisabled) {
            this.element.getElementsByClassName('comparison__check--details')[0].classList.remove('comparison__check--details--hide');
        }
        else {
            this.element.getElementsByClassName('comparison__check--details')[0].classList.add('comparison__check--details--hide');
        }
    };
    Comparison.prototype.renderProduct = function (input) {
        var _this = this;
        var productPrices = "";
        var productTags = "";
        var benefitsAndFeatures = "";
        var productButtons = "";
        input.pricing.forEach(function (price) {
            productPrices += _this.renderProductPrice(price);
        });
        input.tags.forEach(function (tag) {
            productTags += " " + tag.replace(/ /g, "-");
        });
        input.benefitsAndFeatures.forEach(function (ben) {
            benefitsAndFeatures += "<li>" + ben + "</li>";
        });
        var btnCount = 0;
        input.buttons.forEach(function (btn) {
            btnCount++;
            productButtons += _this.renderButtons(btn, input.buttons.length == btnCount, input, btnCount);
        });
        var output = "";
        output += "\n\t\t\t<div class=\"comparison__product-wrapper\" data-id=\"" + input.id + "\" data-trackingregion=\"compare " + this.producttype + (" > " + input.title + "\">\n\n\t\t\t\t<div class=\"comparison__product__header\">\n\t\t\t\t\t" + input.title + "\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"comparison__product__section\" data-section=\"description\">\n\n\t\t\t\t\t<span class=\"title title--notes\">\n\t\t\t\t\t\t" + this.textDescription + "\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t" + input.subTitle + "\n\t\t\t\t\t</p>\n\n\t\t\t\t</div>\n\n\t\t\t\t" + productPrices + "\n\n\t\t\t\t<div class=\"comparison__product__section comparison__product__section--wide\"  data-section=\"apply\">\n                    \n                    <div class=\"comparison__product__section-buttons\">\n                    \n                        " + productButtons + "\n                        \n                    </div>\n\n\t\t\t\t\t<span class=\"title title--notes\">\n\t\t\t\t\t\t" + input.content + "\n\t\t\t\t\t</span>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"comparison__product__benefits\">\n\t\t\t\t\t<span class=\"title title--notes\">\n\t\t\t\t\t\t" + this.textBenefits + "\n\t\t\t\t\t</span>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t" + benefitsAndFeatures + "\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t");
        return document.createRange().createContextualFragment(output);
    };
    Comparison.prototype.renderButtons = function (input, last, product, index) {
        var output = "";
        //Analytics - add the 3rd param to hold product title to cover the below buttons interaction
        var productTitle = product.productTitle ? product.productTitle : product.title;
        var dataIntent = 'Informational';
        var dataClass = 'button--main';
        if (input.buttonClass) {
            var dataButtonClass = input.buttonClass.toLowerCase();
            if (dataButtonClass === 'eligibility') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'callmeback') {
                dataIntent = 'Query';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'apply') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'applywhitebutton') {
                dataIntent = 'Transactional';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contactus') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact us') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'productdetails') {
                dataIntent = 'Informational';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'compare') {
                dataIntent = 'Comparison;';
                dataClass = 'button--white button--border-blue';
            }
        }
        if (input.isModal) {
            output += "\n                <div class=\"comparison__product__button " + (last ? 'comparison__product__button--last' : '') + "\">\n                    <a class=\"button " + dataClass + " js-apply-now-modal-open\"\n                        href=\"#\"\n                        target=\"\"\n                        data-modal=\"apply-now-modal-" + input.modalId + "\"\n\t\t\t\t\t\tdata-intent=\"" + dataIntent + "\"\n\t\t\t\t\t\tdata-scope=\"comparison\"\n                        data-id=\"link_content_compare " + this.producttype + "\"\n                        data-text=\"" + productTitle + (" | " + input.title + " button click\">\n\n                        " + input.title + "\n\n                    </a>\n                </div>\n            ");
        }
        else {
            output += "\n                <div class=\"comparison__product__button " + (last ? 'comparison__product__button--last' : '') + "\">\n                    <a class=\"button " + dataClass + " comparison__mobile__graph__tell-me-more\"\n                        href=\"" + input.url + "\"\n                        target=\"" + input.target + "\"\n\t\t\t\t\t\tdata-intent=\"" + dataIntent + "\"\n\t\t\t\t\t\tdata-scope=\"comparison\"\n                        data-id=\"link_content_compare " + this.producttype + "\"\n                        data-text=\"" + productTitle + (" | " + input.title + " button click\">\n\n                        " + input.title + "\n\n                    </a>\n                </div>\n            ");
        }
        return output;
    };
    Comparison.prototype.renderProductPrice = function (input) {
        var output = "";
        output += "<div class=\"comparison__product__section\" data-section=\"price\">";
        output += "\n\t\t\t<div class=\"title title--notes\">\n\t\t\t\t" + input.subTitle + "\n\t\t\t</div>\n\t\t";
        if (input.symbol) {
            output += "\n\t\t\t\t<span class=\"title title--initial title--currency-med\">\n\t\t\t\t\t" + input.symbol + "\n\t\t\t\t</span>\n\t\t\t";
        }
        output += "\n\t\t\t<span class=\"title title--initial title--number-med\">\n\t\t\t\t" + input.title + "\n\t\t\t</span>\n\t\t";
        if (input.tooltip) {
            output += "\n\t\t\t\t<span title=\"some tooltip\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.strike) {
            output += "\n\t\t\t\t<div class=\"title title--number-strike\">\n\t\t\t\t\t<span class=\"title title--number-striker\"></span>\n\t\t\t";
            if (input.symbol) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--currency-sml\">\n\t\t\t\t\t\t" + input.symbol + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            output += "\n\t\t\t\t\t<span class=\"title title--initial title--number-sml\">\n\t\t\t\t\t\t" + input.strike + "\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t";
        }
        output += "</div>"; //main close
        return output;
    };
    Comparison.prototype.renderComparisonChips = function (item) {
        var output = "";
        output += "\n\n\t\t\t<label data-id=\"" + item.id + "\" class=\"comparison__compare-checkbox form__control form__control--checkbox\">\n\n\t\t\t\t" + item.shortTitle + "\n\t\t\t\t<input type=\"checkbox\" data-id=\"" + item.id + "\" class=\"js-compare\">\n\t\t\t\t<div class=\"form__control-indicator\"></div>\n\n\t\t\t</label>\n\t\t";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        document.querySelector('.comparison__compare-chip-wrapper').appendChild(docfragment);
    };
    Comparison.prototype.compareClick = function (e) {
        e.stopImmediatePropagation();
        var id = $(e.currentTarget).data('id');
        if (this.comparison[this.productKey].find(function (item) { return item == id; })) {
            //remove the product from comparison
            var index = this.comparison[this.productKey].indexOf(id);
            if (index >= 0) {
                this.comparison[this.productKey].splice(index, 1);
                localStorage.setItem('comparison', JSON.stringify(this.comparison));
            }
            if (this.comparisonJson.find(function (item) { return item.id == id; })) {
                var index_1 = _.findIndex(this.comparisonJson, function (o) {
                    return o.id == id;
                });
                if (index_1 >= 0) {
                    this.comparisonJson.splice(index_1, 1);
                    this.removeMobileProduct(id);
                }
            }
            if (this.comparison[this.productKey].length <= 1) {
                $('.comparison__mobile__graph-switcher__arrow').hide();
            }
            else {
                $('.comparison__mobile__graph-switcher__arrow').show();
            }
            if (this.comparison[this.productKey].length < 1) {
                $('.comparison').removeClass('comparison--comparing');
                $(".comparison__compare-chip--active").removeClass('comparison__compare-chip--active');
                this.resetSlots();
                this.resetMobile();
            }
            else {
                $(".comparison__compare-chip--active[data-id='" + id + "']").removeClass('comparison__compare-chip--active');
                //remove column and reorder placeholders
                $(".comparison__product-wrapper[data-id=\"" + id + "\"]").parent().html("\n\t\t\t\t\t<div class=\"comparison__placeholder comparison__placeholder--col\">\n\n\t\t\t\t\t\t<svg viewBox='0 0 300 100' preserveAspectRatio='none'>\n\t\t\t\t\t\t\t<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>\n\t\t\t\t\t\t</svg>\n\n\t\t\t\t\t\t<span class=\"comparison__placeholder__icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-hand\" class=\"icon \">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"34\" viewBox=\"0 0 32 34\">\n\t\t\t\t\t\t\t\t\t<path fill=\"#858D9D\" fill-rule=\"evenodd\" d=\"M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z\"></path>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<span class=\"comparison__placeholder__text\">\n\t\t\t\t\t\t\tUse the tags to select a product to compare\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t</div>\n\t\t\t\t");
                if ($('.comparison__product-wrapper').length >= 1) {
                    this.normalizeHeight();
                    $('.comparison__slot').css('order', 99);
                    $('.comparison__product-wrapper').each(function (idx, item) {
                        $(item).parent().css('order', idx);
                    });
                }
                else {
                    $('.comparison__slot').css('order', 99);
                    $('.comparison__slot').addClass('comparison__slot--hide')
                        .delay(350)
                        .queue(function (next) {
                        $(this).removeClass('comparison__slot--active').removeClass('comparison__slot--hide');
                        $('.comparison__placeholder--large')
                            .removeClass('comparison__placeholder--hide')
                            .removeClass('comparison__placeholder--hidden');
                        next();
                    });
                }
                $(".comparison .form__control--checkbox input").removeAttr('disabled');
            }
            this.normalizeHeight();
        }
        else {
            //product is not compared yet, check to see comparison limit has been met
            var product = this.productJson.find(function (item) {
                return item.id == id;
            });
            if (!$('.comparison').hasClass('comparison--comparing')) {
                $('.comparison').addClass('comparison--comparing');
            }
            if (!this.comparison) {
                this.comparison = [];
                this.comparison[this.productKey].push(id);
                localStorage.setItem('comparison', JSON.stringify(this.comparison));
            }
            else if (this.comparison[this.productKey].length >= 3) {
                $(".comparison .form__control--checkbox input").prop('disabled', 'disabled');
                this.comparison[this.productKey].forEach(function (id) {
                    $(".comparison .form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                });
                e.preventDefault();
            }
            else if (this.comparison[this.productKey].length < 3) {
                this.comparisonJson.push(product);
                var docfragment = document.createDocumentFragment();
                docfragment.appendChild(this.renderProduct(product));
                this.renderSlot(docfragment);
                this.addMobileProduct(product);
                $('.comparison__slot').addClass('comparison__slot--active');
                this.comparison[this.productKey].push(id);
                localStorage.setItem('comparison', JSON.stringify(this.comparison));
                if (this.comparison[this.productKey].length >= 3) {
                    $(".comparison .form__control--checkbox input").prop('disabled', 'disabled');
                    this.comparison[this.productKey].forEach(function (id) {
                        $(".comparison .form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                    });
                }
                this.normalizeHeight();
            }
            if (this.comparison[this.productKey].length <= 1) {
                $('.comparison__mobile__graph-switcher__arrow').hide();
            }
            else {
                $('.comparison__mobile__graph-switcher__arrow').show();
            }
        }
        // Analytics
        var analyticsFinalcompare = [];
        for (var idx = 0, len = this.comparisonJson.length; idx < len; idx++) {
            analyticsFinalcompare.push(this.comparisonJson[idx].title);
        }
        if (analyticsFinalcompare.length) {
            this.analyticsService.dtmGenericUserInteraction("cta_Compare " + this.producttype + "-" + analyticsFinalcompare.join(" > "));
        }
        this.normalizeHeight();
    };
    Comparison.prototype.renderSlot = function (fragment) {
        $('.comparison__slot').each(function (idx, item) {
            var hasProduct = $(item).find('.comparison__product-wrapper').length > 0;
            if (!hasProduct) {
                item.innerHTML = "";
                item.appendChild(fragment);
                return false;
            }
        });
        TooltipsService.initTooltips();
    };
    Comparison.prototype.resetSlots = function () {
        var _this = this;
        $('.comparison__slot').css('order', 99);
        $('.comparison__slot').each(function (idx, el) {
            if ($(el).data('slot') != 3) {
                $(el).html("\n\t\t\t\t\t<div class=\"comparison__placeholder comparison__placeholder--col\">\n\n\t\t\t\t\t\t<svg viewBox='0 0 300 100' preserveAspectRatio='none'>\n\t\t\t\t\t\t\t<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>\n\t\t\t\t\t\t</svg>\n\n\t\t\t\t\t\t<span class=\"comparison__placeholder__icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-hand\" class=\"icon \">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"34\" viewBox=\"0 0 32 34\">\n\t\t\t\t\t\t\t\t\t<path fill=\"#858D9D\" fill-rule=\"evenodd\" d=\"M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z\"></path>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<span class=\"comparison__placeholder__text\">\n\t\t\t\t\t\t\tUse the tags to select a product to compare\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t</div>\n\t\t\t\t");
            }
            else {
                $(el).html("\n\t\t\t\t\t<div class=\"comparison__placeholder comparison__placeholder--col\">\n\n\t\t\t\t\t\t<svg viewBox='0 0 300 100' preserveAspectRatio='none'>\n\t\t\t\t\t\t\t<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>\n\t\t\t\t\t\t</svg>\n\n\t\t\t\t\t\t<span class=\"comparison__placeholder__icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-hand\" class=\"icon \">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"34\" viewBox=\"0 0 32 34\">\n\t\t\t\t\t\t\t\t\t<path fill=\"#858D9D\" fill-rule=\"evenodd\" d=\"M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z\"></path>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<span class=\"comparison__placeholder__text\">\n\t\t\t\t\t\t\tUse the tags to select a product to compare\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<img class=\"comparison__placeholder__image responsive-image responsive-image--animation\"\n\t\t\t\t\t\t\tsrc=\"" + _this.imagePath + "\"\n\t\t\t\t\t\t\talt=\"place holder image\" />\n\n\t\t\t\t\t</div>\n\t\t\t\t");
            }
        });
    };
    Comparison.prototype.resetMobile = function () {
        this.comparisonJson = [];
        this.pricingJson = [];
        $(".comparison__mobile__wrapper").html("\n\n\t\t\t<div class=\"comparison__placeholder comparison__placeholder--col\">\n\n\t\t\t\t<svg viewBox='0 0 300 100' preserveAspectRatio='none'>\n\t\t\t\t\t<path d='M0,0 300,0 300,100 0,100z' vector-effect='non-scaling-stroke'/>\n\t\t\t\t</svg>\n\n\t\t\t\t<span class=\"comparison__placeholder__icon\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-hand\" class=\"icon \">\n\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"34\" viewBox=\"0 0 32 34\">\n\t\t\t\t\t\t\t<path fill=\"#858D9D\" fill-rule=\"evenodd\" d=\"M28.928 20.563v2.075a8.525 8.525 0 0 1-4.464 7.506c-3.18 1.706-7.19 1.156-9.755-1.16L4.161 18.548c2.15-1.222 5.291-.831 7.085.96l1.542 1.545c.377.375.874.582 1.401.582a1.99 1.99 0 0 0 1.99-1.986V4.25c0-.78.634-1.417 1.416-1.417.782 0 1.417.636 1.417 1.417v9.23l9.916 7.083zM21.845 4.25A4.255 4.255 0 0 0 17.595 0a4.255 4.255 0 0 0-4.25 4.25v13.354l-.096-.098c-1.611-1.61-3.873-2.533-6.207-2.533-2.308 0-4.45.867-6.03 2.44L0 18.418l12.763 12.623A11.421 11.421 0 0 0 20.428 34c1.882 0 3.688-.456 5.378-1.36a11.355 11.355 0 0 0 5.956-10.002v-3.534l-9.917-7.084V4.25z\"></path>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\n\t\t\t\t<span class=\"comparison__placeholder__text\">\n\t\t\t\t\tUse the tags to select a product to compare\n\t\t\t\t</span>\n\n\t\t\t</div>\n\n\t\t");
    };
    Comparison.prototype.parsePricing = function () {
        var _this = this;
        this.pricingJson = (_.groupBy(_.flatMap(this.comparisonJson.map(function (product) {
            return product.pricing.map(function (price) {
                price.id = product.id;
                price.productTitle = product.title;
                price.productShortTitle = product.shortTitle;
                price.productLink = product.productLink;
                price.buttons = product.buttons;
                return price;
            });
        })), 'subTitle'));
        _.mapKeys(this.pricingJson, function (value, key) {
            _this.switcherIndex[key] = 0;
            var maxValue = _.max(_.map(_this.pricingJson[key], function (price) {
                return parseInt(price.title);
            }));
            _this.pricingJson[key].forEach(function (price) {
                price.percent = _.round(parseInt(price.title) / maxValue * 100, 0);
            });
        });
    };
    //mobile rendering
    Comparison.prototype.renderMobile = function () {
        var _this = this;
        $(".comparison__mobile__wrapper").html('');
        this.parsePricing();
        var fragment = document.createDocumentFragment();
        var descriptions = "";
        var benefitsAndFeatures = "";
        var priceAccordions = "";
        this.comparisonJson.forEach(function (product, idx, arr) {
            var benefits = "";
            var features = "";
            var productButtons = "";
            var btnCount = 0;
            product.buttons.forEach(function (btn) {
                btnCount++;
                productButtons += _this.renderButtons(btn, product.buttons.length == btnCount, product, btnCount);
            });
            descriptions += "\n\t\t\t<div class=\"comparison__mobile__accordion__content__wrapper\" data-id=\"" + product.id + "\" data-trackingregion=\"compare " + _this.producttype + (" > " + product.title + "\">\n\n\t\t\t\t\t<div class=\"comparison__mobile__title\">\n\t\t\t\t\t\t" + product.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t" + product.subTitle + "\n\t\t\t\t\t</p>\n\n\t\t\t\t\t" + productButtons + "\n\n\t\t\t\t</div>\n\t\t\t");
            product.benefitsAndFeatures.forEach(function (ben) {
                benefits += "<li>" + ben + "</li>";
            });
            benefitsAndFeatures += "\n\t\t\t\t<div class=\"comparison__mobile__accordion__content__wrapper\" data-id=\"" + product.id + "\">\n\n\t\t\t\t\t<div class=\"comparison__mobile__title\">\n\t\t\t\t\t\t" + product.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<span class=\"title title--notes\">\n\t\t\t\t\t\tBENEFITS AND KEY FEATURES\n\t\t\t\t\t</span>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t" + benefits + "\n\t\t\t\t\t</ul>\n\n\t\t\t\t</div>\n\t\t\t";
        });
        _.mapKeys(this.pricingJson, function (value, key) {
            var graphs = "";
            _this.pricingJson[key].sort(function (a, b) {
                return parseInt(a.title) - parseInt(b.title);
            }).forEach(function (price, i) {
                graphs += "\n\n\t\t\t\t\t<div class=\"comparison__mobile__graph-item\" data-id=\"" + price.id + "\">\n\n\t\t\t\t\t\t<div class=\"comparison__mobile__graph__title\">\n\t\t\t\t\t\t\t" + price.productShortTitle + "\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<span class=\"title title--initial title--currency-sml\">\n\t\t\t\t\t\t\t" + price.symbol + "\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<span class=\"title title--initial title--number-sml\">\n\n\t\t\t\t\t\t\t" + price.title + "\n\n\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t<div class=\"comparison__mobile__graph__bar\">\n\n\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph__bar__fill " + (i == 0 ? 'comparison__mobile__graph__bar__fill--active' : '') + "\" style=\"width: " + price.percent + "%\">\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t";
            });
            var pricingButtons = "";
            var btnCount = 0;
            _this.pricingJson[key][0].buttons.forEach(function (btn) {
                btnCount++;
                pricingButtons += _this.renderButtons(btn, _this.pricingJson[key][0].buttons.length == btnCount, value[0], btnCount);
            });
            priceAccordions += "\n\t\t\t<div class=\"comparison__mobile__accordion\" data-section=\"" + key + "\" data-id=\"link_accordion_accordion\" data-text=\"compare " + _this.producttype + (" | " + key + "\" >\n\n\t\t\t\t\t<span class=\"comparison__mobile__accordion__heading\">\n\t\t\t\t\t\t" + key + "\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<span class=\"comparison__mobile__chevron\">\n\n\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"link-chevron\" class=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?-->\n\t\t\t\t\t\t\t<svg width=\"6px\" height=\"9px\" viewBox=\"0 0 6 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n\t\t\t\t\t\t\t\t<g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t<g id=\"Dsk-/-arrow-/-blue\" fill-rule=\"nonzero\" fill=\"#0089FF\">\n\t\t\t\t\t\t\t\t\t<polygon id=\"flechita\" points=\"1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981\"></polygon>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t</i>\n\n\t\t\t\t\t</span>\n\n\t\t\t\t\t<div class=\"comparison__mobile__accordion__content\" data-trackingregion=\"compare ") + _this.producttype + (" > " + value[0].productTitle + "\">\n\n\t\t\t\t\t\t<div class=\"comparison__mobile__graph-wrapper\">\n\n\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph-wrapper__inner\">\n\t\t\t\t\t\t\t\t" + graphs + "\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph-switcher\" data-key=\"" + key + "\">\n\t\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph-switcher__arrow comparison__mobile__graph-switcher__arrow--left\">\n\t\t\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"arrow-left-slider\" class=\"icon \">\n\t\t\t\t\t\t\t\t\t\t<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18.57 33.23\"><defs><style>.cls-1{fill:url(#linear-gradient);}</style><linearGradient id=\"linear-gradient\" y1=\"16.61\" x2=\"18.57\" y2=\"16.61\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#ffb94f\"/><stop offset=\"1\" stop-color=\"#ff5a00\"/></linearGradient></defs><title>arrow-left-2</title><polygon id=\"Fill-4\" class=\"cls-1\" points=\"16.61 33.23 18.57 31.27 3.92 16.61 18.57 1.96 16.61 0 0 16.61 16.61 33.23\"/></svg>\n\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<span class=\"comparison__mobile__graph-switcher__value\" data-key=\"" + key + "\">" + value[0].productTitle + "</span>\n\n\t\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph-switcher__arrow comparison__mobile__graph-switcher__arrow--right\">\n\t\t\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"arrow-right-slider\" class=\"icon \">\n\t\t\t\t\t\t\t\t\t\t<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18.57 33.23\"><defs><style>.cls-1{fill:url(#linear-gradient);}</style><linearGradient id=\"linear-gradient\" y1=\"16.61\" x2=\"18.57\" y2=\"16.61\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#ffb94f\"/><stop offset=\"1\" stop-color=\"#ff5a00\"/></linearGradient></defs><title>arrow-right-2</title><polygon id=\"Fill-4\" class=\"cls-1\" points=\"1.96 33.23 0 31.27 14.66 16.61 0 1.96 1.96 0 18.57 16.61 1.96 33.23\"/></svg>\n\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n                            <div class=\"comparison__mobile-graph-buttons\">\n\n                                " + pricingButtons + "\n                                \n                            </div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\t\t\t");
        });
        var descriptionOutput = "\n\t\t\t<div class=\"comparison__mobile__accordion\" data-section=\"description\" data-id=\"link_accordion_accordion\" data-text=\"compare " + this.producttype + (" | description\">\n\n\t\t\t\t<span class=\"comparison__mobile__accordion__heading\">\n\t\t\t\t\tDescription\n\t\t\t\t</span>\n\n\t\t\t\t<span class=\"comparison__mobile__chevron\">\n\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"link-chevron\" class=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?-->\n\t\t\t\t\t\t<svg width=\"6px\" height=\"9px\" viewBox=\"0 0 6 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n\t\t\t\t\t\t\t<g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t<g id=\"Dsk-/-arrow-/-blue\" fill-rule=\"nonzero\" fill=\"#0089FF\">\n\t\t\t\t\t\t\t\t<polygon id=\"flechita\" points=\"1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981\"></polygon>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\n\t\t\t\t</span>\n\n\t\t\t\t<div class=\"comparison__mobile__accordion__content\">\n\n\t\t\t\t\t" + descriptions + "\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t");
        var benefitsAndFeaturesOutput = "\n\t\t<div class=\"comparison__mobile__accordion\" data-section=\"benefits\" data-id=\"link_accordion_accordion\" data-text=\"compare " + this.producttype + (" | benefits & key features\">\n\n\t\t\t\t<span class=\"comparison__mobile__accordion__heading\">\n\t\t\t\t\tBENEFITS & KEY FEATURES\n\t\t\t\t</span>\n\n\t\t\t\t<span class=\"comparison__mobile__chevron\">\n\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"link-chevron\" class=\"icon \"><!--?xml version=\"1.0\" encoding=\"UTF-8\"?-->\n\t\t\t\t\t\t<svg width=\"6px\" height=\"9px\" viewBox=\"0 0 6 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n\t\t\t\t\t\t\t<g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t<g id=\"Dsk-/-arrow-/-blue\" fill-rule=\"nonzero\" fill=\"#0089FF\">\n\t\t\t\t\t\t\t\t<polygon id=\"flechita\" points=\"1.22288019 9 5.72288019 4.5 1.22288019 0 0 0.322880195 4.17711981 4.5 0 8.67711981\"></polygon>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\n\t\t\t\t</span>\n\n\t\t\t\t<div class=\"comparison__mobile__accordion__content\">\n\n\t\t\t\t\t" + benefitsAndFeatures + "\n\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t");
        fragment.appendChild(document.createRange().createContextualFragment(descriptionOutput));
        fragment.appendChild(document.createRange().createContextualFragment(priceAccordions));
        fragment.appendChild(document.createRange().createContextualFragment(benefitsAndFeaturesOutput));
        document.querySelector('.comparison__mobile__wrapper').appendChild(fragment);
    };
    Comparison.prototype.addMobileProduct = function (product) {
        var _this = this;
        if (document.querySelectorAll('.comparison__mobile__accordion').length > 0) {
            this.parsePricing();
            _.mapKeys(this.pricingJson, function (value, key) {
                var graphs = "";
                _this.pricingJson[key].sort(function (a, b) {
                    return parseInt(a.title) - parseInt(b.title);
                }).forEach(function (price, i) {
                    graphs += "\n\n\t\t\t\t\t\t<div class=\"comparison__mobile__graph-item\" data-id=\"" + price.id + "\">\n\n\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph__title\">\n\t\t\t\t\t\t\t\t" + price.productShortTitle + "\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<span class=\"title title--initial title--currency-sml\">\n\t\t\t\t\t\t\t\t" + price.symbol + "\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<span class=\"title title--initial title--number-sml\">\n\n\t\t\t\t\t\t\t\t" + price.title + "\n\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph__bar\">\n\n\t\t\t\t\t\t\t\t<div class=\"comparison__mobile__graph__bar__fill " + (i == 0 ? 'comparison__mobile__graph__bar__fill--active' : '') + "\" style=\"width: " + price.percent + "%\">\n\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t";
                });
                $(".comparison__mobile__accordion[data-section=\"" + key + "\"] .comparison__mobile__graph-wrapper__inner")
                    .html(graphs);
            });
            var productButtons_1 = "";
            var btnCount_1 = 0;
            product.buttons.forEach(function (btn) {
                btnCount_1++;
                productButtons_1 += _this.renderButtons(btn, product.buttons.length == btnCount_1, product, btnCount_1);
            });
            var descriptionFragment = document.createDocumentFragment();
            descriptionFragment.appendChild(document.createRange().createContextualFragment("\n\t\t\t\t<div class=\"comparison__mobile__accordion__content__wrapper\" data-id=\"" + product.id + "\">\n\n\t\t\t\t\t<div class=\"comparison__mobile__title\">\n\t\t\t\t\t\t" + product.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t" + product.subTitle + "\n\t\t\t\t\t</p>\n\n\t\t\t\t\t" + productButtons_1 + "\n\n\t\t\t\t</div>\n\t\t\t"));
            document.querySelector('.comparison__mobile__accordion[data-section="description"] > .comparison__mobile__accordion__content')
                .appendChild(descriptionFragment);
            var priceAccordions = "";
            var benefits_1 = "";
            var features = "";
            product.benefitsAndFeatures.forEach(function (ben) {
                benefits_1 += "<li>" + ben + "</li>";
            });
            var benefitFragment = document.createDocumentFragment();
            benefitFragment.appendChild(document.createRange().createContextualFragment("\n\t\t\t\t<div class=\"comparison__mobile__accordion__content__wrapper\" data-id=\"" + product.id + "\">\n\n\t\t\t\t\t<div class=\"comparison__mobile__title\">\n\t\t\t\t\t\t" + product.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<span class=\"title title--notes\">\n\t\t\t\t\t\tBENEFITS AND KEY FEATURES\n\t\t\t\t\t</span>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t" + benefits_1 + "\n\t\t\t\t\t</ul>\n\n\t\t\t\t</div>\n\t\t\t"));
            document.querySelector('.comparison__mobile__accordion[data-section="benefits"] > .comparison__mobile__accordion__content')
                .appendChild(benefitFragment);
        }
        else {
            this.renderMobile();
        }
    };
    Comparison.prototype.removeMobileProduct = function (id) {
        $(".comparison__mobile__accordion__content__wrapper[data-id=\"" + id + "\"]").remove();
        $(".comparison__mobile__graph-item[data-id=\"" + id + "\"]").remove();
    };
    return Comparison;
}(Base));
export { Comparison };



//////////////////
// WEBPACK FOOTER
// ./components/comparison/comparison.component.ts
// module id = 202
// module chunks = 0